import React from "react";

const PractitionerTextDetails = ({ practitionerDetailData }) => {
  console.log(practitionerDetailData);
  return (
    <div className="info">
      <div>
        <span className="label">Name - </span>
        Dr. {practitionerDetailData?.resource?.name[0].given[0]}{" "}
        {practitionerDetailData?.resource?.name[0].given[1]}
      </div>
    </div>
  );
};

export default PractitionerTextDetails;
